import React from 'react';
import PropTypes from 'prop-types';
import { Input, Checkbox, Tooltip, message } from 'antd';
import { Link } from 'react-router-dom';
import { FormattedMessage, injectIntl } from 'react-intl';
import Portlet from '../../utils/portlet';

import copy from '../../utils/copyClipboard';
const TextArea = Input.TextArea;

export class CodeForm extends React.Component {
  static propTypes = {
    data: PropTypes.object.isRequired,
    onSaveClientDataChange: PropTypes.func.isRequired,
  }
  _onCopy = value => {
    copy(value)
    message.success(
      this.props.intl.formatMessage({id: 'analytics.copied', defaultMessage: 'Copied'}), 1
    )
  }
  render() {
    const {data, isOwnFormChecked, checkOwnForm} = this.props;
    return (
      <Portlet>
        <FormattedMessage
          id="code.description"
          defaultMessage='The script should be placed after the </form> tag and immediately before the end of the </body> tag. If your forms have multiple steps / follow a funnel, then this script should be placed on every page in the funnel.' />
          <Tooltip 
            title={this.props.intl.formatMessage({id: 'analytics.click-to-copy', defaultMessage: 'Click to copy code'})}
          >
            <TextArea
              onClick={() => this._onCopy(data ? data.code : '')}
              style={{ margin: '13px 0', cursor: 'pointer'}}
              value={data ? data.code : ''}
              autosize={{ minRows: 2, maxRows: 6 }}
              readOnly={true}
            />
          </Tooltip>
          <Tooltip title={
            (<span>
              <FormattedMessage
                id="code.save-client-data-tip"
                defaultMessage='Enabling this option allows to determine the lead authenticity and some more filters. '
              />
              <Link to='/help/pixel'>
                <FormattedMessage id="code.more" defaultMessage='More...' />
              </Link>
            </span>)
          }>
            <Checkbox
              checked={data ? data.saveClientData : false}
              onChange={this.props.onSaveClientDataChange}
            >
              <FormattedMessage id="code.save-client-data" defaultMessage='Save client data' />
            </Checkbox>
          </Tooltip>
          <Tooltip title={
            (<span>
              <FormattedMessage
                id="list.ownForm"
                defaultMessage='The inclusion of this option allows all the collected leads in this form to be considered sold.'
              />
            </span>)
          }>
            <Checkbox
              checked={isOwnFormChecked}
              onChange={checkOwnForm}
            >
              <FormattedMessage id="list.ownForm.title" defaultMessage='Own form' />
            </Checkbox>
          </Tooltip>
      </Portlet>
    )
  }
}

export default injectIntl(CodeForm)


// WEBPACK FOOTER //
// ./src/components/dashboard/projects/code.js